// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customLink_disabled__KNUHP {
  pointer-events: none;
  cursor: default;
  opacity: 0.5;
}

.customLink_active_link__Xdf-F {
  color: var(--secondary-color) !important;
  position: relative;
}
.customLink_active_link__Xdf-F::before {
  content: "";
  position: absolute;
  width: 100%;
  border-bottom: 2px solid var(--secondary-color);
  bottom: -10px;
}
@media (max-width: 991px) {
  .customLink_active_link__Xdf-F::before {
    bottom: -5px;
  }
}

.customLink_small_light_green__axBNp {
  width: fit-content;
  background-color: var(--green-light);
  border: 2px solid var(--green-light);
  border-radius: 12px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s;
}
.customLink_small_light_green__axBNp a {
  display: block;
  padding: 12px 24px;
  width: 100%;
  height: 100%;
  text-decoration: none;
  border-bottom: none !important;
  color: #2e706c !important;
  text-align: center;
  transition: all 0.3s;
}
.customLink_small_light_green__axBNp:hover {
  background-color: var(--primary-color-hover);
  border: 2px solid var(--primary-color-hover);
  transform: scale(102%);
  transition: all 0.3s;
}
.customLink_small_light_green__axBNp:hover a {
  background-color: var(--primary-color);
  border: 2px solid var(--primary-color);
  color: #ffffff !important;
  transition: all 0.3s;
}
.customLink_small_light_green__axBNp:active {
  transform: scale(0.98);
  transition: all 0.3s;
}

.customLink_small_green__-rGSO {
  width: fit-content;
  min-width: 150px;
  background-color: var(--primary-color);
  border: 2px solid var(--primary-color);
  border-radius: 12px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s;
}
.customLink_small_green__-rGSO a {
  display: block;
  padding: 12px 24px;
  width: 100%;
  height: 100%;
  text-decoration: none;
  border-bottom: none !important;
  color: white !important;
  text-align: center;
  transition: all 0.3s;
}
.customLink_small_green__-rGSO:hover {
  background-color: var(--primary-color-hover);
  border: 2px solid var(--primary-color-hover);
  transform: scale(102%);
  transition: all 0.3s;
}
.customLink_small_green__-rGSO:active {
  background-color: var(--primary-color);
  border: 2px solid var(--primary-color);
  transform: scale(0.98);
  transition: all 0.3s;
}
@media (max-width: 991px) {
  .customLink_small_green__-rGSO a {
    padding: 10px 20px;
  }
}

.customLink_green_outlined__l7QwS {
  width: fit-content;
  min-width: 150px;
  background-color: transparent;
  border: 2px solid var(--primary-color);
  border-radius: 12px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: var(--primary-color);
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s;
}
.customLink_green_outlined__l7QwS a {
  display: block;
  padding: 12px 24px;
  width: 100%;
  height: 100%;
  text-decoration: none;
  color: var(--primary-color) !important;
  text-align: center;
  transition: all 0.3s;
}
.customLink_green_outlined__l7QwS a::before {
  content: none;
}
.customLink_green_outlined__l7QwS:hover {
  background-color: var(--primary-color-hover);
  border: 2px solid var(--primary-color-hover);
  transform: scale(102%);
  transition: all 0.3s;
}
.customLink_green_outlined__l7QwS:hover a {
  color: #ffffff !important;
  transition: all 0.3s;
}
.customLink_green_outlined__l7QwS:active {
  background-color: var(--primary-color);
  border: 2px solid var(--primary-color);
  transform: scale(0.98);
  transition: all 0.3s;
}
@media (max-width: 991px) {
  .customLink_green_outlined__l7QwS {
    min-width: 100px;
    font-size: 11px;
  }
  .customLink_green_outlined__l7QwS a {
    padding: 7px 10px;
  }
}

.customLink_light_green_outlined__P3Ozh {
  width: fit-content;
  background-color: transparent;
  border: 2px solid var(--green-light);
  border-radius: 12px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s;
}
.customLink_light_green_outlined__P3Ozh a {
  display: block;
  padding: 12px 24px;
  width: 100%;
  height: 100%;
  text-decoration: none;
  border-bottom: none !important;
  color: var(--green-light) !important;
  text-align: center;
  transition: all 0.3s;
}
.customLink_light_green_outlined__P3Ozh:hover {
  background-color: var(--green-light);
  transform: scale(102%);
  transition: all 0.3s;
}
.customLink_light_green_outlined__P3Ozh:hover a {
  color: #2e706c !important;
  transition: all 0.3s;
}
.customLink_light_green_outlined__P3Ozh:active {
  transform: scale(0.98);
  transition: all 0.3s;
}
@media (max-width: 991px) {
  .customLink_light_green_outlined__P3Ozh {
    font-size: 12px;
  }
  .customLink_light_green_outlined__P3Ozh a {
    padding: 10px 10px;
  }
}

.customLink_orange__5ZgfJ {
  width: fit-content;
  background-color: var(--secondary-color);
  border: 2px solid var(--secondary-color);
  border-radius: 12px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: white;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s;
}
.customLink_orange__5ZgfJ a {
  display: block;
  padding: 12px 24px;
  width: 100%;
  height: 100%;
  text-decoration: none;
  border-bottom: none !important;
  color: #ffffff !important;
  text-align: center;
  transition: all 0.3s;
}
.customLink_orange__5ZgfJ:hover {
  background-color: var(--secondary-color-hover);
  border: 2px solid var(--secondary-color-hover);
  transform: scale(102%);
  transition: all 0.3s;
}
.customLink_orange__5ZgfJ:active {
  background-color: var(--secondary-color);
  border: 2px solid var(--secondary-color);
  transform: scale(0.98);
  transition: all 0.3s;
}
@media (max-width: 991px) {
  .customLink_orange__5ZgfJ {
    font-size: 12px;
  }
  .customLink_orange__5ZgfJ a {
    padding: 10px 10px;
  }
}

.customLink_orange_outlined__4YQA8 {
  width: fit-content;
  min-width: 150px;
  background-color: transparent;
  border: 2px solid var(--secondary-color);
  border-radius: 12px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s;
}
.customLink_orange_outlined__4YQA8 a {
  display: block;
  padding: 12px 24px;
  width: 100%;
  height: 100%;
  text-decoration: none;
  border-bottom: none !important;
  color: var(--secondary-color) !important;
  text-align: center;
  transition: all 0.3s;
}
.customLink_orange_outlined__4YQA8 a::before {
  content: none;
}
.customLink_orange_outlined__4YQA8:hover {
  background-color: var(--secondary-color);
  transform: scale(102%);
  transition: all 0.3s;
}
.customLink_orange_outlined__4YQA8:hover a {
  color: white !important;
  transition: all 0.3s;
}
.customLink_orange_outlined__4YQA8:active {
  transform: scale(0.98);
  transition: all 0.3s;
}
@media (max-width: 991px) {
  .customLink_orange_outlined__4YQA8 {
    font-size: 12px;
  }
  .customLink_orange_outlined__4YQA8 a {
    padding: 10px 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/CustomLink/customLink.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,eAAA;EACA,YAAA;AACF;;AACA;EACE,wCAAA;EACA,kBAAA;AAEF;AAAE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,+CAAA;EACA,aAAA;AAEJ;AACE;EACE;IACE,YAAA;EACJ;AACF;;AAGA;EACE,kBAAA;EACA,oCAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,oBAAA;AAAF;AAEE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;AAAJ;AAGE;EACE,4CAAA;EACA,4CAAA;EACA,sBAAA;EACA,oBAAA;AADJ;AAGI;EACE,sCAAA;EACA,sCAAA;EACA,yBAAA;EACA,oBAAA;AADN;AAKE;EACE,sBAAA;EACA,oBAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,sCAAA;EACA,sCAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,oBAAA;AAJF;AAME;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;AAJJ;AAOE;EACE,4CAAA;EACA,4CAAA;EACA,sBAAA;EACA,oBAAA;AALJ;AAQE;EACE,sCAAA;EACA,sCAAA;EACA,sBAAA;EACA,oBAAA;AANJ;AASE;EACE;IACE,kBAAA;EAPJ;AACF;;AAWA;EACE,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,sCAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,yBAAA;EACA,eAAA;EACA,oBAAA;AARF;AAUE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sCAAA;EACA,kBAAA;EACA,oBAAA;AARJ;AAUI;EACE,aAAA;AARN;AAYE;EACE,4CAAA;EACA,4CAAA;EACA,sBAAA;EACA,oBAAA;AAVJ;AAYI;EACE,yBAAA;EACA,oBAAA;AAVN;AAcE;EACE,sCAAA;EACA,sCAAA;EACA,sBAAA;EACA,oBAAA;AAZJ;AAeE;EAhDF;IAiDI,gBAAA;IACA,eAAA;EAZF;EAaE;IACE,iBAAA;EAXJ;AACF;;AAeA;EACE,kBAAA;EACA,6BAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,oBAAA;AAZF;AAcE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,8BAAA;EACA,oCAAA;EACA,kBAAA;EACA,oBAAA;AAZJ;AAeE;EACE,oCAAA;EACA,sBAAA;EACA,oBAAA;AAbJ;AAeI;EACE,yBAAA;EACA,oBAAA;AAbN;AAiBE;EACE,sBAAA;EACA,oBAAA;AAfJ;AAkBE;EAxCF;IAyCI,eAAA;EAfF;EAgBE;IACE,kBAAA;EAdJ;AACF;;AAkBA;EACE,kBAAA;EACA,wCAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,oBAAA;AAfF;AAiBE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;AAfJ;AAkBE;EACE,8CAAA;EACA,8CAAA;EACA,sBAAA;EACA,oBAAA;AAhBJ;AAmBE;EACE,wCAAA;EACA,wCAAA;EACA,sBAAA;EACA,oBAAA;AAjBJ;AAoBE;EAvCF;IAwCI,eAAA;EAjBF;EAkBE;IACE,kBAAA;EAhBJ;AACF;;AAoBA;EACE,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,oBAAA;AAjBF;AAmBE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,8BAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;AAjBJ;AAmBI;EACE,aAAA;AAjBN;AAqBE;EACE,wCAAA;EACA,sBAAA;EACA,oBAAA;AAnBJ;AAqBI;EACE,uBAAA;EACA,oBAAA;AAnBN;AAuBE;EACE,sBAAA;EACA,oBAAA;AArBJ;AAwBE;EA7CF;IA8CI,eAAA;EArBF;EAsBE;IACE,kBAAA;EApBJ;AACF","sourcesContent":[".disabled {\n  pointer-events: none;\n  cursor: default;\n  opacity: 0.5;\n}\n.active_link {\n  color: var(--secondary-color) !important;\n  position: relative;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    border-bottom: 2px solid var(--secondary-color);\n    bottom: -10px;\n  }\n\n  @media (max-width: 991px) {\n    &::before {\n      bottom: -5px;\n    }\n  }\n}\n\n.small_light_green {\n  width: fit-content;\n  background-color: var(--green-light);\n  border: 2px solid var(--green-light);\n  border-radius: 12px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.3s;\n\n  a {\n    display: block;\n    padding: 12px 24px;\n    width: 100%;\n    height: 100%;\n    text-decoration: none;\n    border-bottom: none !important;\n    color: #2e706c !important;\n    text-align: center;\n    transition: all 0.3s;\n  }\n\n  &:hover {\n    background-color: var(--primary-color-hover);\n    border: 2px solid var(--primary-color-hover);\n    transform: scale(102%);\n    transition: all 0.3s;\n\n    a {\n      background-color: var(--primary-color);\n      border: 2px solid var(--primary-color);\n      color: #ffffff !important;\n      transition: all 0.3s;\n    }\n  }\n\n  &:active {\n    transform: scale(0.98);\n    transition: all 0.3s;\n  }\n}\n\n.small_green {\n  width: fit-content;\n  min-width: 150px;\n  background-color: var(--primary-color);\n  border: 2px solid var(--primary-color);\n  border-radius: 12px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.3s;\n\n  a {\n    display: block;\n    padding: 12px 24px;\n    width: 100%;\n    height: 100%;\n    text-decoration: none;\n    border-bottom: none !important;\n    color: white !important;\n    text-align: center;\n    transition: all 0.3s;\n  }\n\n  &:hover {\n    background-color: var(--primary-color-hover);\n    border: 2px solid var(--primary-color-hover);\n    transform: scale(102%);\n    transition: all 0.3s;\n  }\n\n  &:active {\n    background-color: var(--primary-color);\n    border: 2px solid var(--primary-color);\n    transform: scale(0.98);\n    transition: all 0.3s;\n  }\n\n  @media (max-width: 991px) {\n    a {\n      padding: 10px 20px;\n    }\n  }\n}\n\n.green_outlined {\n  width: fit-content;\n  min-width: 150px;\n  background-color: transparent;\n  border: 2px solid var(--primary-color);\n  border-radius: 12px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  color: var(--primary-color);\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.3s;\n\n  a {\n    display: block;\n    padding: 12px 24px;\n    width: 100%;\n    height: 100%;\n    text-decoration: none;\n    color: var(--primary-color) !important;\n    text-align: center;\n    transition: all 0.3s;\n\n    &::before {\n      content: none;\n    }\n  }\n\n  &:hover {\n    background-color: var(--primary-color-hover);\n    border: 2px solid var(--primary-color-hover);\n    transform: scale(102%);\n    transition: all 0.3s;\n\n    a {\n      color: #ffffff !important;\n      transition: all 0.3s;\n    }\n  }\n\n  &:active {\n    background-color: var(--primary-color);\n    border: 2px solid var(--primary-color);\n    transform: scale(0.98);\n    transition: all 0.3s;\n  }\n\n  @media (max-width: 991px) {\n    min-width: 100px;\n    font-size: 11px;\n    a {\n      padding: 7px 10px;\n    }\n  }\n}\n\n.light_green_outlined {\n  width: fit-content;\n  background-color: transparent;\n  border: 2px solid var(--green-light);\n  border-radius: 12px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.3s;\n\n  a {\n    display: block;\n    padding: 12px 24px;\n    width: 100%;\n    height: 100%;\n    text-decoration: none;\n    border-bottom: none !important;\n    color: var(--green-light) !important;\n    text-align: center;\n    transition: all 0.3s;\n  }\n\n  &:hover {\n    background-color: var(--green-light);\n    transform: scale(102%);\n    transition: all 0.3s;\n\n    a {\n      color: #2e706c !important;\n      transition: all 0.3s;\n    }\n  }\n\n  &:active {\n    transform: scale(0.98);\n    transition: all 0.3s;\n  }\n\n  @media (max-width: 991px) {\n    font-size: 12px;\n    a {\n      padding: 10px 10px;\n    }\n  }\n}\n\n.orange {\n  width: fit-content;\n  background-color: var(--secondary-color);\n  border: 2px solid var(--secondary-color);\n  border-radius: 12px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  color: white;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.3s;\n\n  a {\n    display: block;\n    padding: 12px 24px;\n    width: 100%;\n    height: 100%;\n    text-decoration: none;\n    border-bottom: none !important;\n    color: #ffffff !important;\n    text-align: center;\n    transition: all 0.3s;\n  }\n\n  &:hover {\n    background-color: var(--secondary-color-hover);\n    border: 2px solid var(--secondary-color-hover);\n    transform: scale(102%);\n    transition: all 0.3s;\n  }\n\n  &:active {\n    background-color: var(--secondary-color);\n    border: 2px solid var(--secondary-color);\n    transform: scale(0.98);\n    transition: all 0.3s;\n  }\n\n  @media (max-width: 991px) {\n    font-size: 12px;\n    a {\n      padding: 10px 10px;\n    }\n  }\n}\n\n.orange_outlined {\n  width: fit-content;\n  min-width: 150px;\n  background-color: transparent;\n  border: 2px solid var(--secondary-color);\n  border-radius: 12px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.3s;\n\n  a {\n    display: block;\n    padding: 12px 24px;\n    width: 100%;\n    height: 100%;\n    text-decoration: none;\n    border-bottom: none !important;\n    color: var(--secondary-color) !important;\n    text-align: center;\n    transition: all 0.3s;\n\n    &::before {\n      content: none;\n    }\n  }\n\n  &:hover {\n    background-color: var(--secondary-color);\n    transform: scale(102%);\n    transition: all 0.3s;\n\n    a {\n      color: white !important;\n      transition: all 0.3s;\n    }\n  }\n\n  &:active {\n    transform: scale(0.98);\n    transition: all 0.3s;\n  }\n\n  @media (max-width: 991px) {\n    font-size: 12px;\n    a {\n      padding: 10px 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disabled": `customLink_disabled__KNUHP`,
	"active_link": `customLink_active_link__Xdf-F`,
	"small_light_green": `customLink_small_light_green__axBNp`,
	"small_green": `customLink_small_green__-rGSO`,
	"green_outlined": `customLink_green_outlined__l7QwS`,
	"light_green_outlined": `customLink_light_green_outlined__P3Ozh`,
	"orange": `customLink_orange__5ZgfJ`,
	"orange_outlined": `customLink_orange_outlined__4YQA8`
};
export default ___CSS_LOADER_EXPORT___;
